module.exports = __webpack_public_path__ + "static/img/azpz.204d477.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/azpz.jpeg
// module id = 8oUc
// module chunks = 3